module.exports = __webpack_public_path__ + "img/bb-info-dataimport-gitonline.d177629b.png";